'use client';

/**
 * PremiumTrustBar — barra trust elegante 4 colonne, no clutter.
 * Posizionata prima del footer principale.
 */

import { ShieldCheck, Lock, Headphones, RefreshCw } from 'lucide-react';

const TRUST_ITEMS = [
  { icon: ShieldCheck, title: 'Operatori verificati', desc: 'Ogni partner controllato dal nostro team' },
  { icon: Lock, title: 'Prenotazione sicura', desc: 'Pagamenti protetti e crittografati' },
  { icon: Headphones, title: 'Assistenza dedicata', desc: 'Supporto in italiano 7/7 prima e durante' },
  { icon: RefreshCw, title: 'Cancellazione flessibile', desc: 'Modifica o annulla secondo policy' },
];

export default function PremiumTrustBar() {
  return (
    <section
      data-cid="premium-trust-bar"
      className="relative w-full py-16 md:py-20 px-6 md:px-12 bg-slate-50 border-y border-slate-200/60"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {TRUST_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.title} className="flex flex-col items-start gap-3">
                <div className="w-11 h-11 rounded-xl bg-white ring-1 ring-slate-200 flex items-center justify-center shadow-sm">
                  <Icon className="w-5 h-5 text-blue-700" strokeWidth={1.6} />
                </div>
                <div>
                  <h3 className="font-display font-black text-slate-900 text-sm md:text-base leading-tight">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-[13px] text-slate-500 mt-1 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
